import { Injectable, inject, signal, computed } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

export interface UserProfile {
  sub: string;
  name?: string;
  email?: string;
  preferred_username?: string;
  given_name?: string;
  family_name?: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly oidc = inject(OidcSecurityService);

  readonly isAuthenticated = toSignal(
    this.oidc.isAuthenticated$.pipe(map(r => r.isAuthenticated)),
    { initialValue: false }
  );

  readonly userData = toSignal(this.oidc.userData$, { initialValue: null });
  readonly isLoading = signal(false);

  readonly userProfile = computed<UserProfile | null>(() => {
    const data = this.userData();
    if (!data) return null;
    const ud = (data as any).userData ?? data;
    return ud as UserProfile;
  });

  checkAuth() {
    return this.oidc.checkAuth();
  }

  login(): void {
    this.oidc.authorize();
  }

  logout(): void {
    this.oidc.logoff().subscribe();
  }
}
